import React, { memo } from 'react';
import { Platform, Pressable } from 'react-native';

import { SvgIcon, Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

type Props = {
  label: string;
  onPress: () => void;
};

/** Destructive "Leave circle" button shown to a co-guardian (non-primary). */
function LeaveCircleButton({ label, onPress }: Props) {
  const styles = useStyles();
  const { scale } = useScaling();

  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={label}
      onPress={onPress}
      style={({ pressed }) => [styles.button, pressed ? styles.pressed : null]}>
      <SvgIcon name="IcLeave" size={scale(20)} color={colors['Level 3']} />
      <Text variant="Font Guardian App/Subtitle/Subtitle 14 Semibold" style={styles.label}>
        {label}
      </Text>
    </Pressable>
  );
}

export default memo(LeaveCircleButton);

const useStyles = createStyles(({ scale }) => ({
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: scale(8),
    height: scale(48),
    padding: scale(10),
    borderRadius: scale(12),
    borderCurve: 'continuous',
    borderWidth: 0.5,
    borderColor: guardianColors.Error,
    backgroundColor: colors['0'],
    ...(Platform.OS === 'ios'
      ? {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 1 },
          shadowOpacity: 0.2,
          shadowRadius: 1,
        }
      : {
          elevation: 2,
        }),
  },
  pressed: {
    opacity: 0.7,
  },
  label: {
    color: colors['Level 3'],
  },
}));
